import { authHeader, history } from "../_helpers";
import config from "../config";
import { handleResponse } from "../_helpers/response";
import axios from "axios";
const baseUrl = config.apiGateway.baseUrl;
export const gangDetectionService = {
  AllocatedGangDetectionModule,
  AllocatedGangDetectionModuleList,
  AllocatedGagDetectionCityId,
  getGangPaginate,
  getGangDetails,
  updateGang,
  getGraph,
  getGangIdsFirs,
  GangMemberList,
};

function AllocatedGangDetectionModuleList() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/gang-detection/list/`, requestOptions);
}
function AllocatedGangDetectionModule(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/gang-detection/`, requestOptions);
}
function AllocatedGagDetectionCityId(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/gang-detection/allocated-gang-detection/${cityId}`,
    requestOptions,
  );
}
function getGangPaginate(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/gang-paginate`, requestOptions).then(handleResponse);
}
function getGangDetails(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/gang-details/`, requestOptions).then(handleResponse);
}
function updateGang(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/gang-update/`, requestOptions).then(handleResponse);
}
function getGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/gang-graph/`, requestOptions).then(handleResponse);
}
function getGangIdsFirs(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/get_gang_ids_fir/`, requestOptions).then(
    handleResponse,
  );
}
function GangMemberList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/memeber-list/`, requestOptions).then(handleResponse);
}
